<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="font-weight-bold text-h4">
          {{ value.modalHeading }}
        </v-card-title>
        <hr />
        <v-card-text>
          <v-form ref="form" v-model="isValid" id="credit-card-form">
            <div class="card-label">
              <label for="Card-Name">Card Name</label>
            </div>
            <v-text-field
              ref="cardName"
              autofocus
              class="v-text-field-transparent"
              v-model.trim="value.cardName"
              name="Card-Name"
              :rules="cardNameRules"
              required
              @keyup.enter="cardNameNextFocus"
            >
            </v-text-field>
            <div class="card-label">
              <label for="Short-Card-Name">Short Card Name</label>
            </div>
            <v-text-field
              ref="shortCardName"
              v-model.trim="value.shortCardName"
              class="v-text-field-transparent"
              name="Short-Card-Name"
              :rules="shortCardNameRules"
              required
              :disabled="value.submitButtonTitle == 'Update'"
              @keyup.enter="startingDigitsFocus"
            >
            </v-text-field>
            <div class="card-label">
              <label for="Card-Starting-Digits">Card Starting Digits</label>
            </div>
            <v-text-field
              ref="startingDigits"
              v-model.trim="value.startingDigits"
              class="v-text-field-transparent"
              name="Card-Starting-Digits"
              type="number"
              :rules="startingDigitRules"
              required
              @keyup.enter="cardLengthFocus"
            >
            </v-text-field>
            <div class="card-label">
              <label for="Card-Length">Card Length</label>
            </div>
            <v-text-field
              ref="cardLength"
              v-model.trim="value.constraints.cardLength"
              class="v-text-field-transparent"
              name="Card-Length"
              type="number"
              @keyup.enter="submitForm"
              :rules="cardLengthRule"
              required
            >
            </v-text-field>
            <div class="card-label">
              <label for="Card-Length">CVC Minimum Length</label>
            </div>
            <v-text-field
              ref="cvcMinLength"
              v-model.trim="value.constraints.cvcMinLength"
              class="v-text-field-transparent"
              name="CVC-Minimum-Length"
              type="number"
              @keyup.enter="submitForm"
              :rules="cvcMinLengthRule"
              required
            >
            </v-text-field>
            <div class="card-label">
              <label for="Card-Length">CVC Maxium Length</label>
            </div>
            <v-text-field
              ref="cvcMaxLength"
              v-model.trim="value.constraints.cvcMaxLength"
              class="v-text-field-transparent"
              name="CVC-Maximum-Length"
              type="number"
              @keyup.enter="submitForm"
              :rules="cvcMaxLengthRule"
              required
            >
            </v-text-field>
          </v-form>
        </v-card-text>
        <hr />
        <v-card-actions>
          <v-btn
            color="green darken-2"
            text
            @click="submitForm"
            :disabled="
              value.submitButtonTitle == 'Save'
                ? !isValid
                : !areFieldsChanged || !isValid
            "
          >
            {{ value.submitButtonTitle }}
          </v-btn>
          <v-spacer />
          <v-btn color="grey darken-1" text @click="closeModal">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    initialData: Object,
    entireList: {
      type: Array,
      default() {
        return [];
      }
    },
    manualFormReset: Boolean
  },
  data() {
    return {
      cardNameRules: [fieldValue => !!fieldValue || "Card Name Is Required."],
      shortCardNameRules: [
        fieldValue => !!fieldValue || "An Short Card Name Is Required.",
        fieldValue => {
          if (this.value.submitButtonTitle == "Save")
            return (
              !this.searchList(fieldValue) || `${fieldValue} Already Exists.`
            );
          return true;
        },
        fieldValue => !/[\s]/.test(fieldValue) || "No Space Allowed.",
        fieldValue =>
          /^[A-Za-z0-9]+$/.test(fieldValue) ||
          "Only Letters And Numbers Allowed."
      ],
      startingDigitRules: [
        fieldValue => !!fieldValue || "Starting Digits Are Required.",
        fieldValue => /^[0-9]+$/.test(fieldValue) || "Remove The Decimal."
      ],
      cardLengthRule: [
        fieldValue => !!fieldValue || "Card Length Is Required.",
        fieldValue => /^[0-9]+$/.test(fieldValue) || "Remove The Decimal."
      ],
      cvcMinLengthRule: [
        fieldValue => !!fieldValue || "CVC Minium Length Is Required.",
        fieldValue => /^[0-9]+$/.test(fieldValue) || "Remove The Decimal."
      ],
      cvcMaxLengthRule: [
        fieldValue => !!fieldValue || "CVC Maximum Length Is Required.",
        fieldValue => /^[0-9]+$/.test(fieldValue) || "Remove The Decimal."
      ],
      isValid: false
    };
  },
  watch: {
    manualFormReset: function() {
      this.resetForm();
    }
  },
  computed: {
    areFieldsChanged() {
      if (this.value.submitButtonTitle != "Update") return true;
      if (
        this.initialData.cardName != this.value.cardName ||
        this.initialData.shortCardName != this.value.shortCardName ||
        this.initialData.startingDigits != this.value.startingDigits ||
        this.initialData.constraints.cvcMinLength !=
          this.value.constraints.cvcMinLength ||
        this.initialData.constraints.cvcMaxLength !=
          this.value.constraints.cvcMaxLength ||
        this.initialData.constraints.cardLength !=
          this.value.constraints.cardLength
      ) {
        return true;
      }
      return false;
    },
    cardTypeInfo() {
      return {
        cardName: this.value.cardName,
        shortCardName: this.value.shortCardName,
        startingDigits: this.value.startingDigits,
        constraints: {
          cardLength: this.value.constraints.cardLength,
          cvcMinLength: this.value.constraints.cvcMinLength,
          cvcMaxLength: this.value.constraints.cvcMaxLength
        }
      };
    }
  },
  methods: {
    closeModal() {
      this.resetForm();
      this.$emit("eCloseCardTypeCRUDModal");
    },
    resetForm() {
      this.$refs.form.reset();
    },
    createCardType() {
      this.$emit("eCreateCardType", this.cardTypeInfo);
    },
    updateCardType() {
      this.$emit("eUpdateCardType", this.cardTypeInfo);
    },
    isFormValid() {
      if (this.value.submitButtonTitle == "Save") return this.isValid;

      return this.areFieldsChanged && this.isValid;
    },
    submitForm() {
      if (!this.isFormValid()) return;
      this.value.submitButtonTitle == "Save"
        ? this.createCardType()
        : this.updateCardType();
    },
    cardNameNextFocus() {
      this.value.submitButtonTitle == "Save"
        ? this.shortCardNameFocus()
        : this.startingDigitsFocus();
    },
    shortCardNameFocus() {
      this.submitForm();
      this.$refs.shortCardName.focus();
    },
    startingDigitsFocus() {
      this.submitForm();
      this.$refs.startingDigits.focus();
    },
    cardLengthFocus() {
      this.submitForm();
      this.$refs.cardLength.focus();
    },
    cvcMinLengthFocus() {
      this.submitForm();
      this.$refs.cvcMinLength.focus();
    },
    cvcMaxLengthFocus() {
      this.submitForm();
      this.$refs.cvcMaxLength.focus();
    },
    searchList(fieldValue) {
      let index = this.entireList.findIndex(
        list => list.shortCardName == fieldValue
      );
      if (index >= 0) return true;

      return false;
    }
  }
};
</script>
<style>
#credit-card-form {
  display: flex;
  flex-direction: column !important;
}
.v-text-field-transparent > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}
.v-text-field-transparent > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}
.v-text-field-transparent
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  box-sizing: border-box;
  min-height: 40.5px;
  width: 300.5px;
  border: 0.5px solid #d8d8e4;
  border-radius: 4px;
  background-color: #ffffff;
  padding: 1px 10px 1px 10px;
}
.v-text-field-transparent {
  padding: 0;
}
.card-label > label {
  font-weight: 700;
  font-size: 14px;
  color: black;
}
</style>
